"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveEduLicence = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const isActiveEduLicence = (licence) => licence.isActive && licence.type === bridge_schema_1.LicenseType.Edu;
const getActiveEduLicence = (licenses) => licenses.find(licence => isActiveEduLicence(licence));
exports.getActiveEduLicence = getActiveEduLicence;
